import * as Block from "bs-platform/lib/es6/block.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as Printf from "bs-platform/lib/es6/printf.js";
import * as $$String from "bs-platform/lib/es6/string.js";
import * as Caml_option from "bs-platform/lib/es6/caml_option.js";
import * as Bolt0_int$Bolt0 from "bolt0/./bolt0_int.bs.js";
import * as Bolt0_list$Bolt0 from "bolt0/./bolt0_list.bs.js";
import * as Term$SolvuuLang0 from "solvuu-lang0/./term.bs.js";
import * as Table$SolvuuLang0 from "solvuu-lang0/./table.bs.js";
import * as Record$SolvuuLang0 from "solvuu-lang0/./record.bs.js";
import * as Lang_var$SolvuuApi0 from "./lang_var.bs.js";
import * as Caml_builtin_exceptions from "bs-platform/lib/es6/caml_builtin_exceptions.js";
import * as Lang_term_bs$SolvuuApi0 from "./lang_term_bs.bs.js";
import * as Lang_type_bs$SolvuuApi0 from "./lang_type_bs.bs.js";
import * as Lang_label_bs$SolvuuApi0 from "./lang_label_bs.bs.js";
import * as Lang_term_atd$SolvuuApi0 from "./lang_term_atd.bs.js";
import * as Lang_type_atd$SolvuuApi0 from "./lang_type_atd.bs.js";
import * as Lang_label_atd$SolvuuApi0 from "./lang_label_atd.bs.js";

function to_string(param) {
  if (param[0] >= 699531161) {
    return param[1];
  } else {
    return Curry._1(Printf.sprintf(
    /* Format */
    [
    /* Int */
    Block.__(4, [
    /* Int_d */
    0,
    /* No_padding */
    0,
    /* No_precision */
    0,
    /* End_of_format */
    0]), "%d"]), param[1]);
  }
}

function equal(x, y) {
  var variant = x[0];

  if (variant !== 699531161) {
    if (variant >= 948354667) {
      if (y[0] >= 948354667) {
        return $$String.equal(x[1], y[1]);
      } else {
        return false;
      }
    } else if (y[0] >= 699531161) {
      return false;
    } else {
      return x[1] === y[1];
    }
  } else if (y[0] !== 699531161) {
    return false;
  } else {
    return $$String.equal(x[1], y[1]);
  }
}

function compare_pnu(x, y) {
  var variant = x[0];

  if (variant !== 699531161) {
    if (variant >= 948354667) {
      if (y[0] >= 948354667) {
        return $$String.compare(x[1], y[1]);
      } else {
        return 1;
      }
    } else if (y[0] >= 699531161) {
      return -1;
    } else {
      return Bolt0_int$Bolt0.compare(x[1], y[1]);
    }
  } else {
    var variant$1 = y[0];

    if (variant$1 !== 699531161) {
      if (variant$1 >= 948354667) {
        return -1;
      } else {
        return 1;
      }
    } else {
      return $$String.compare(x[1], y[1]);
    }
  }
}

function named_exn(x) {
  return (
    /* `Named */
    [699531161, x]
  );
}

function positional_exn(x) {
  return (
    /* `Positional */
    [-300665356, x]
  );
}

var Var = Lang_var$SolvuuApi0;

function eval_error(message, t) {
  return (
    /* `Error */
    [106380200,
    /* `Eval */
    [771069884,
    /* tuple */
    [t, message]]]
  );
}

function type_error(typ, message, t) {
  return (
    /* `Error */
    [106380200,
    /* `Type */
    [937565914,
    /* tuple */
    [t, typ, message]]]
  );
}

function $$var(x) {
  return (
    /* `Var */
    [4298439, x]
  );
}

function list(l) {
  return (
    /* `List */
    [848054398, l]
  );
}

function record(l) {
  return (
    /* `Record */
    [847309489, Bolt0_list$Bolt0.map(function (param) {
      return (
        /* tuple */
        [
        /* `Named */
        [699531161, param[0]], param[1]]
      );
    }, l)]
  );
}

function tuple(l) {
  return (
    /* `Record */
    [847309489, Bolt0_list$Bolt0.mapi(function (i, e) {
      return (
        /* tuple */
        [
        /* `Positional */
        [-300665356, i + 1 | 0], e]
      );
    }, l)]
  );
}

function nullable(to_term, x) {
  if (x !== undefined) {
    return (
      /* `Some */
      [925978388, Curry._1(to_term, Caml_option.valFromOption(x))]
    );
  } else {
    return (
      /* Null */
      870828711
    );
  }
}

function bool(x) {
  return (
    /* `Bool */
    [737456202, x]
  );
}

function $$float(x) {
  return (
    /* `Float */
    [365180284, x]
  );
}

function $$int(x) {
  return (
    /* `Int */
    [3654863, x]
  );
}

function string(x) {
  return (
    /* `String */
    [-976970511, x]
  );
}

function app(f, x) {
  return (
    /* `App */
    [3257473,
    /* tuple */
    [f, x]]
  );
}

function lambda($$var, body) {
  return (
    /* `Lambda */
    [89433895,
    /* tuple */
    [$$var, body]]
  );
}

function let_in($$var, e1, e2) {
  return app(lambda($$var, e2), e1);
}

function project(t, l) {
  return app(
  /* `Project */
  [-1019462983, l], t);
}

function const_string(body) {
  var match = $$String.equal("x", body);
  var x = match ? "y" : "x";
  return (
    /* `Lambda */
    [89433895,
    /* tuple */
    [x,
    /* `String */
    [-976970511, body]]]
  );
}

var of_term = Term$SolvuuLang0.Let.of_term;
var to_term = Term$SolvuuLang0.Let.to_term;
var Let = {
  of_term: of_term,
  to_term: to_term
};

function keys(t) {
  return Bolt0_list$Bolt0.map(function (prim) {
    return prim[0];
  }, t);
}

function find(t, key) {
  return Bolt0_list$Bolt0.find_opt(t, function (param) {
    var match = equal(key, param[0]);

    if (match) {
      return param[1];
    }
  });
}

function of_alist(l) {
  var lst = Bolt0_list$Bolt0.sort(function (param, param$1) {
    return compare_pnu(param[0], param$1[0]);
  }, l);

  if (lst) {
    var _last_seen = lst[0][0];
    var _l = lst[1];

    while (true) {
      var l$1 = _l;
      var last_seen = _last_seen;

      if (l$1) {
        var key = l$1[0][0];
        var match = equal(key, last_seen);

        if (match) {
          return (
            /* `Duplicate_key */
            [-1048878709, key]
          );
        } else {
          _l = l$1[1];
          _last_seen = key;
          continue;
        }
      } else {
        return (
          /* `Ok */
          [17724, lst]
        );
      }
    }

    ;
  } else {
    return (
      /* `Ok */
      [17724, lst]
    );
  }
}

function to_alist(l) {
  return l;
}

function add(t, key, data) {
  var match = of_alist(
  /* :: */
  [
  /* tuple */
  [key, data], t]);

  if (match[0] >= 17724) {
    return (
      /* `Ok */
      [17724, match[1]]
    );
  } else {
    return (
      /* Duplicate */
      -1024851605
    );
  }
}

function add_positional(t, data) {
  var n = Bolt0_list$Bolt0.fold_left(function (acc, param) {
    var label = param[0];

    if (label[0] >= 699531161) {
      return acc;
    } else {
      var n = label[1];

      if (n > acc) {
        return n;
      } else {
        return acc;
      }
    }
  }, 0, t);
  var key_001 = n + 1 | 0;
  var key =
  /* `Positional */
  [-300665356, key_001];
  var match = add(t, key, data);

  if (typeof match === "number") {
    throw [Caml_builtin_exceptions.assert_failure,
    /* tuple */
    ["lang.ml", 181, 20]];
  }

  return match[1];
}

function remove(t, key) {
  return Bolt0_list$Bolt0.filter_map(t, function (x) {
    if (equal(key, x[0])) {
      return x;
    }
  });
}

function update(t, key, f) {
  var loop = function loop(_found, _acc, _param) {
    while (true) {
      var param = _param;
      var acc = _acc;
      var found = _found;

      if (param) {
        var rest = param[1];
        var match = param[0];
        var this_data = match[1];
        var this_key = match[0];

        if (equal(this_key, key)) {
          _param = rest;
          _acc =
          /* :: */
          [
          /* tuple */
          [this_key, Curry._1(f, this_data)], acc];
          _found = true;
          continue;
        } else {
          _param = rest;
          _acc =
          /* :: */
          [
          /* tuple */
          [this_key, this_data], acc];
          continue;
        }
      } else {
        return (
          /* tuple */
          [found, acc]
        );
      }
    }

    ;
  };

  var match = loop(false,
  /* [] */
  0, t);

  if (match[0]) {
    return match[1];
  } else {
    return (
      /* :: */
      [
      /* tuple */
      [key, Curry._1(f, undefined)], t]
    );
  }
}

function filter_mapi(t, f) {
  return Bolt0_list$Bolt0.filter_map(t, function (param) {
    var key = param[0];

    var match = Curry._2(f, key, param[1]);

    if (match !== undefined) {
      return (
        /* tuple */
        [key, match]
      );
    }
  });
}

function tagged(tag, data) {
  var match = of_alist(
  /* :: */
  [
  /* tuple */
  [
  /* `Positional */
  [-300665356, 1],
  /* `String */
  [-976970511, tag]],
  /* :: */
  [
  /* tuple */
  [
  /* `Positional */
  [-300665356, 2], data],
  /* [] */
  0]]);

  if (match[0] >= 17724) {
    return match[1];
  } else {
    throw [Caml_builtin_exceptions.assert_failure,
    /* tuple */
    ["lang.ml", 211, 26]];
  }
}

var partial_arg = {
  keys: keys,
  find: find,
  add: add,
  add_positional: add_positional,
  remove: remove,
  filter_mapi: filter_mapi,
  of_alist: of_alist,
  to_alist: to_alist,
  tagged: tagged
};
var partial_arg$1 = Record$SolvuuLang0.Param.Make;

var Param = function (param) {
  return partial_arg$1(partial_arg, param);
}({
  to_string: to_string,
  named_exn: named_exn,
  positional_exn: positional_exn
});

var Table = Table$SolvuuLang0.Make(Param);
var Label = {
  Json: Lang_label_bs$SolvuuApi0,
  json_of_t: Lang_label_atd$SolvuuApi0.json_of_t,
  t_of_json: Lang_label_atd$SolvuuApi0.t_of_json,
  to_string: to_string,
  named_exn: named_exn,
  positional_exn: positional_exn,
  equal: equal,
  compare_pnu: compare_pnu
};
var Type = {
  Json: Lang_type_bs$SolvuuApi0,
  json_of_scalar: Lang_type_atd$SolvuuApi0.json_of_scalar,
  json_of_nullable_type: Lang_type_atd$SolvuuApi0.json_of_nullable_type,
  json_of_list_type: Lang_type_atd$SolvuuApi0.json_of_list_type,
  json_of_arrow: Lang_type_atd$SolvuuApi0.json_of_arrow,
  json_of_var: Lang_type_atd$SolvuuApi0.json_of_var,
  json_of_t: Lang_type_atd$SolvuuApi0.json_of_t,
  scalar_of_json: Lang_type_atd$SolvuuApi0.scalar_of_json,
  nullable_type_of_json: Lang_type_atd$SolvuuApi0.nullable_type_of_json,
  list_type_of_json: Lang_type_atd$SolvuuApi0.list_type_of_json,
  arrow_of_json: Lang_type_atd$SolvuuApi0.arrow_of_json,
  var_of_json: Lang_type_atd$SolvuuApi0.var_of_json,
  t_of_json: Lang_type_atd$SolvuuApi0.t_of_json
};
var Term_unit =
/* `Record */
[847309489,
/* [] */
0];
var Term = {
  Json: Lang_term_bs$SolvuuApi0,
  json_of_fmt0: Lang_term_atd$SolvuuApi0.json_of_fmt0,
  json_of_lang_term: Lang_term_atd$SolvuuApi0.json_of_lang_term,
  json_of_blob_id: Lang_term_atd$SolvuuApi0.json_of_blob_id,
  json_of_job_id: Lang_term_atd$SolvuuApi0.json_of_job_id,
  json_of_label: Lang_term_atd$SolvuuApi0.json_of_label,
  json_of_term_id: Lang_term_atd$SolvuuApi0.json_of_term_id,
  json_of_type0: Lang_term_atd$SolvuuApi0.json_of_type0,
  json_of_var: Lang_term_atd$SolvuuApi0.json_of_var,
  json_of_lang_term_future: Lang_term_atd$SolvuuApi0.json_of_lang_term_future,
  json_of_lang_term_error: Lang_term_atd$SolvuuApi0.json_of_lang_term_error,
  json_of_future: Lang_term_atd$SolvuuApi0.json_of_future,
  json_of_error: Lang_term_atd$SolvuuApi0.json_of_error,
  json_of_date: Lang_term_atd$SolvuuApi0.json_of_date,
  json_of_time: Lang_term_atd$SolvuuApi0.json_of_time,
  json_of_env: Lang_term_atd$SolvuuApi0.json_of_env,
  json_of_intrinsic: Lang_term_atd$SolvuuApi0.json_of_intrinsic,
  json_of_meta: Lang_term_atd$SolvuuApi0.json_of_meta,
  json_of_item: Lang_term_atd$SolvuuApi0.json_of_item,
  json_of_map: Lang_term_atd$SolvuuApi0.json_of_map,
  json_of_dir: Lang_term_atd$SolvuuApi0.json_of_dir,
  json_of_t: Lang_term_atd$SolvuuApi0.json_of_t,
  fmt0_of_json: Lang_term_atd$SolvuuApi0.fmt0_of_json,
  lang_term_of_json: Lang_term_atd$SolvuuApi0.lang_term_of_json,
  blob_id_of_json: Lang_term_atd$SolvuuApi0.blob_id_of_json,
  job_id_of_json: Lang_term_atd$SolvuuApi0.job_id_of_json,
  label_of_json: Lang_term_atd$SolvuuApi0.label_of_json,
  term_id_of_json: Lang_term_atd$SolvuuApi0.term_id_of_json,
  type0_of_json: Lang_term_atd$SolvuuApi0.type0_of_json,
  var_of_json: Lang_term_atd$SolvuuApi0.var_of_json,
  lang_term_future_of_json: Lang_term_atd$SolvuuApi0.lang_term_future_of_json,
  lang_term_error_of_json: Lang_term_atd$SolvuuApi0.lang_term_error_of_json,
  future_of_json: Lang_term_atd$SolvuuApi0.future_of_json,
  error_of_json: Lang_term_atd$SolvuuApi0.error_of_json,
  date_of_json: Lang_term_atd$SolvuuApi0.date_of_json,
  time_of_json: Lang_term_atd$SolvuuApi0.time_of_json,
  env_of_json: Lang_term_atd$SolvuuApi0.env_of_json,
  intrinsic_of_json: Lang_term_atd$SolvuuApi0.intrinsic_of_json,
  meta_of_json: Lang_term_atd$SolvuuApi0.meta_of_json,
  item_of_json: Lang_term_atd$SolvuuApi0.item_of_json,
  map_of_json: Lang_term_atd$SolvuuApi0.map_of_json,
  dir_of_json: Lang_term_atd$SolvuuApi0.dir_of_json,
  t_of_json: Lang_term_atd$SolvuuApi0.t_of_json,
  eval_error: eval_error,
  type_error: type_error,
  bool: bool,
  $$var: $$var,
  list: list,
  unit: Term_unit,
  record: record,
  tuple: tuple,
  nullable: nullable,
  $$float: $$float,
  $$int: $$int,
  string: string,
  app: app,
  lambda: lambda,
  let_in: let_in,
  project: project,
  const_string: const_string,
  Let: Let
};
var Record = {
  of_alist: of_alist,
  add: add,
  add_positional: add_positional,
  remove: remove,
  update: update,
  find: find,
  keys: keys,
  tagged: tagged,
  Param: Param
};
export { Label, Var, Type, Term, Record, Table };
/* Param Not a pure module */